export default "__VITE_ASSET__C3WhIm54__"